module.exports = __webpack_public_path__ + "img/03.ba49ba87.png";